'use client';
import styles from './field.module.css';
import { useRef, useTransition } from 'react';
import { FieldIconsProps } from '@/types/field';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faInfo,
	faLocationArrow,
} from '@awesome.me/kit-012d1b9af0/icons/classic/solid';

export function Field({ children }: { children: React.ReactNode }) {
	return <div className={styles.field}>{children}</div>;
}

Field.Icons = ({ icon, children, onClick, animate }: FieldIconsProps) => {
	const ref = useRef<SVGSVGElement>(null);
	const [isPending, startTransition] = useTransition();

	const handleIconClick = async () => {
		startTransition(() => {
			onClick?.();
		});
	};

	return (
		<>
			<div className={styles['icon-container']} onClick={handleIconClick}>
				<FontAwesomeIcon
					ref={ref}
					icon={icon}
					size='xl'
					className={`${styles['main-icon']}`}
					spin={animate && isPending}
				/>
				<FontAwesomeIcon
					icon={animate ? faLocationArrow : faInfo}
					size='xl'
					className={styles['info-icon']}
				/>
			</div>
			{children}
		</>
	);
};

Field.Content = ({
	title,
	labelValue,
	value,
	onFieldChange,
	onHome = true,
}: {
	title: string;
	labelValue: { value: string; label: string }[];
	value: string;
	onFieldChange: (newValue: string) => void;
	onHome?: boolean;
}) => {
	return (
		<div className={styles['select-container']}>
			<label className={`${!onHome && styles.label}`} htmlFor={title}>
				{title}
			</label>
			<select
				id={title}
				className={styles.select}
				onChange={(e) => onFieldChange(e.target.value)}
				value={value}
			>
				{labelValue.map((lv) => (
					<option key={lv.value} value={lv.value} className={styles.option}>
						{lv.label}
					</option>
				))}
			</select>
		</div>
	);
};
